import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Showroom from "@/pages/Showroom";
import ShowroomVisit from "@/pages/ShowroomVisit";
import Materials from "@/pages/Materials";
import Portfolio from "@/pages/Portfolio";
import PortfolioDetail from "@/pages/PortfolioDetail";
import Financing from "@/pages/Financing";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import Support from "@/pages/Support";
import Privacy from "@/pages/Privacy";
import Booking from "@/pages/Booking";
import Visualizer from "@/pages/Visualizer";
import Admin from "@/pages/Admin";
import Landing from "@/pages/Landing";
import { captureUtm } from "@/lib/sleek";

export default function App() {
  useEffect(() => { captureUtm(); }, []);
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/showroom" element={<Showroom />} />
          <Route path="/showroom/materials" element={<Materials />} />
          <Route path="/visit" element={<ShowroomVisit />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/portfolio/:id" element={<PortfolioDetail />} />
          <Route path="/financing" element={<Financing />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/support" element={<Support />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/visualizer" element={<Visualizer />} />
        </Route>
        <Route path="/admin" element={<Admin />} />
        <Route path="/kitchens" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}
